<template>
  <div class="base-container">
    <template v-if="displayStyle===1">
      <div class="list-container">
        <div class="oild-list">
          <slot name="body"></slot>
        </div>
      </div>
      <div class="select-base">
        <material-select :type="type" @selected="handleSelectedImg">
          <template slot="body">
            <div class="add-new">
              <div class="text">{{rightButtonTile.slice(0,2)}}</div>
              <div class="text">{{rightButtonTile.slice(-2)}}</div>
            </div>
          </template>
        </material-select>
      </div>
    </template>
    <template v-else>
      <div class="list-container-two">
        <div class="oild-list">
          <slot name="body"></slot>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";

export default {
  components: { MaterialSelect },
  props: {
    rightButtonTile: {
      type: String,
    },
    type: {
      default: 1,
      type: Number,
    },
    displayStyle: { default: 1, type: Number },
  },
  methods: {
    handleSelectedImg(item) {
      this.$emit("selectChange", item);
    },
  },
};
</script>

<style lang="less" scoped>
.base-container {
  display: flex;
  align-items: center;
  width: 100%;
  .list-container {
    // background-color: rgba(51, 51, 51, 1);
    overflow-x: auto;
    width: calc(100% - 50px);
    .oild-list {
      display: flex;
      padding: 8px 0;
    }
  }
  .list-container-two {
    background-color: rgba(51, 51, 51, 1);
    overflow-x: auto;
    width: 100%;
    .oild-list {
      display: flex;
      padding: 8px 0;
    }
  }
  .add-new {
    width: 47px;
    height: 47px;
    color: white;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(90, 90, 90, 1);
    text-align: center;
    font-size: 12px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>